import type {
  PrintStatus,
  PurchaseCancellation,
  PurchaseCommittedSnapshot,
  PurchaseLimitLedgerEntry,
  PurchasePostCommitNote,
  StationContextRef,
} from '../../purchases/purchases.dto.js';

export const purchaseSyncEventTypeValues = [
  'purchaseCommitted',
  'purchaseCanceled',
  'purchasePrintStatusUpdated',
  'purchaseNoteAdded',
  'purchaseLimitLedgerEntryRecorded',
] as const;
export type PurchaseSyncEventType = (typeof purchaseSyncEventTypeValues)[number];

export const purchaseSyncEntityTypeValues = ['purchase', 'purchaseLimitLedgerEntry'] as const;
export type PurchaseSyncEntityType = (typeof purchaseSyncEntityTypeValues)[number];

export interface PurchaseCommittedEventPayload {
  schemaVersion: 1 | 2;
  purchase: PurchaseCommittedSnapshot;
  printStatus: PrintStatus;
}

export interface PurchaseCanceledEventPayload {
  schemaVersion: 1;
  cancellation: PurchaseCancellation;
}

export interface PurchasePrintStatusUpdatedEventPayload {
  schemaVersion: 1 | 2;
  purchaseId: string;
  station: StationContextRef;
  printStatus: PrintStatus;
  actorUserId: string;
}

export interface PurchaseNoteAddedEventPayload {
  schemaVersion: 1;
  note: PurchasePostCommitNote;
}

export interface PurchaseLimitLedgerEntryRecordedEventPayload {
  schemaVersion: 1;
  entry: PurchaseLimitLedgerEntry;
}
